import { Modifier } from '@dnd-kit/core';
import { getEventCoordinates } from '@dnd-kit/utilities';

const POINTER_GAP_X_PX = 12;
const POINTER_OVERLAP_Y_PX = 2;

export const anchorOverlayToPointerTopRight: Modifier = ({
  activatorEvent,
  draggingNodeRect,
  transform,
}) => {
  if (!activatorEvent || !draggingNodeRect) {
    return transform;
  }

  const activatorCoordinates = getEventCoordinates(activatorEvent);

  if (!activatorCoordinates) {
    return transform;
  }

  return {
    ...transform,
    x: transform.x + activatorCoordinates.x - draggingNodeRect.left + POINTER_GAP_X_PX,
    y:
      transform.y +
      activatorCoordinates.y -
      draggingNodeRect.top -
      draggingNodeRect.height +
      POINTER_OVERLAP_Y_PX,
  };
};
